(function () {
  'use strict';

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      var fx = el.getAttribute('data-fx');

      if (fx === 'counter') {
        el.classList.add('fx-visible');
        animateCounter(el);
      } else {
        el.classList.add('fx-visible');
      }

      observer.unobserve(el);
    });
  }, {
    threshold: 0.1,
    rootMargin: '0px 0px -30px 0px'
  });

  function init() {
    // Pre-process stagger containers — observe each child individually
    // so each card only fires when IT enters the viewport, not all at once
    document.querySelectorAll('[data-fx="stagger"]').forEach(function (container) {
      Array.from(container.children).forEach(function (child, i) {
        child.setAttribute('data-fx', 'fade-up');
        child.style.transitionDelay = (i * 0.1) + 's';
      });
      container.removeAttribute('data-fx');
    });

    // Observe every individual data-fx element
    document.querySelectorAll('[data-fx]').forEach(function (el) {
      observer.observe(el);
    });
  }

  function animateCounter(el) {
    var raw = el.getAttribute('data-fx-count');
    if (!raw) return;
    var suffix = raw.replace(/[\d,\.]/g, '');
    var target = parseInt(raw.replace(/[^\d]/g, ''), 10);
    if (isNaN(target)) return;
    var duration = 1800;
    var startTime = null;

    function step(now) {
      if (!startTime) startTime = now;
      var elapsed = now - startTime;
      var progress = Math.min(elapsed / duration, 1);
      var eased = 1 - Math.pow(1 - progress, 3);
      var current = Math.round(eased * target);
      el.textContent = current.toLocaleString() + suffix;
      if (progress < 1) {
        requestAnimationFrame(step);
      } else {
        el.textContent = raw;
      }
    }

    requestAnimationFrame(step);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
